import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormControl, FormHelperText, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';

const RHFToggleGroup = ({ control, options, name, label }) => {
    const CHIP = (isActive) => ({
        display: 'inline-flex', alignItems: 'center', px: 1.25, py: 0.5,
        borderRadius: '10px', fontSize: '12px', fontWeight: 600, cursor: 'pointer',
        border: '1px solid', transition: 'all 150ms ease', userSelect: 'none', whiteSpace: 'nowrap',
        ...(isActive
            ? { borderColor: '#00AB55', color: '#00AB55', background: 'rgba(0,171,85,0.06)' }
            : { borderColor: 'rgba(145,158,171,0.24)', color: '#637381', background: 'transparent', '&:hover': { borderColor: '#919EAB', background: '#fafafa' } }),
    });

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <FormControl>
                    <Typography sx={{ fontSize: '10px', color: '#919EAB', textTransform: 'uppercase', letterSpacing: '0.3px', fontWeight: 600, mb: 0.75 }}>{label}</Typography>
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                        {options?.map((option, index) => (
                            <Box key={index} role="button" tabIndex={0} aria-pressed={field.value === option.value}
                                onClick={() => { if (field.value === option.value) field.onChange(''); else field.onChange(option.value); }}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (field.value === option.value) field.onChange(''); else field.onChange(option.value); } }}
                                sx={CHIP(field.value === option.value)}>
                                {option.label}
                            </Box>
                        ))}
                    </Box>
                    {error && !field.value &&
                        <FormHelperText error sx={{ px: 0, mt: 0.5, textTransform: 'capitalize' }}>{error?.message}</FormHelperText>}
                </FormControl>
            )}
        />
    );
};

RHFToggleGroup.propTypes = {
    control: PropTypes.object,
    options: PropTypes.array,
    name: PropTypes.string,
    label: PropTypes.string,
};

export default RHFToggleGroup;
